<template>
<div class="chapter">
<div class="inner_page">
<p class="crt2"><a id="page_ii"> <i>Broken Slate</i></a></p><a id="page_ii">
<p class="crt">© 2017 John A. Daly. All rights reserved.</p>
<p class="crt1">No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, digital, mechanical or photocopying, recording, scanning, or otherwise, except for inclusion in a review or as permitted under Sections 107 and 108 of the United States Copyright Act, without either prior written permission of the Publisher, or authorization through payment of the appropriate per-copy fee to the Copyright Clearance Center.</p>
<p class="crt1">This is a work of fiction. All of the characters, names, incidents, organizations, and dialogue in this novel are either the products of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.</p>
<p class="crt1">Published in the United States by BQB Publishing</p>
<p class="crt">(an imprint of Boutique of Quality Books Publishing, Inc.)</p>
</a><p class="crt"><a id="page_ii"></a><a href="http://www.bqbpublishing.com" target="_blank">www.bqbpublishing.com</a></p>
<p class="crt1">978-1-945448-08-9 (p)</p>
<p class="crt">978-1-945448-09-6 (e)</p>
<p class="crt1">Library of Congress Control Number: 2017936395</p>
<p class="crt1">Book design by Robin Krauss, <a href="http://www.bookformatters.com" target="_blank">www.bookformatters.com</a></p>
<p class="crt">Cover design by Ellis Dixon, <a href="http://www.ellisdixon.com" target="_blank">www.ellisdixon.com</a></p>
<p class="crt">First editor: Kimberly Fout</p>
<p class="crt">Second Editor: Olivia Swenson</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightpage.vue?0c191da7